export const getSpacesByKey = async (spaceKeys) => {
  try {
    const spaces = await Promise.all(
      spaceKeys.map(async (key) => {
        const response = await window.AP.request(`/api/v2/spaces/${key}`);
        const body = JSON.parse(response.body);
        const space = body.results[0];
        return space;
      })
    );
    return spaces;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const searchSpaces = async (query) => {
  const url = query
    ? `/rest/api/search?cql=type=space and (space.title~"${query}*" or space.key IN ("${query}"))&limit=25&expand=space.icon,space.homepage`
    : `/rest/api/search?cql=type=space&limit=25&expand=space.icon,space.homepage`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch spaces");
    console.log(e);
    return false;
  }
};

export async function getUserByAccountId(accountId) {
  const url = "/rest/api/user?accountId=" + accountId;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch user", accountId);
    console.log(e);
    return undefined;
  }
}

export async function findUsersByName(query) {
  const url = query
    ? `/rest/api/search/user?cql=user.fullname~"${query}"*`
    : `/rest/api/search/user?cql=user.fullname~"*"*`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch users", query);
    console.log(e);
    return undefined;
  }
}

export function getProfilePictureUrl(path) {
  const hostUrl = window.AP._hostOrigin;
  if (hostUrl === null) {
    console.error("No AP object on window");
  }
  return hostUrl + path;
}

export async function searchForBlogs(query, limit = 25) {
  const url = `/rest/api/search?cql=type=blogpost and (title~"${query}*")&limit=${limit}&expand=content.history,content.space&excerpt=none`;
  try {
    const res = await window.AP.request(url);
    const body = JSON.parse(res.body);
    return body;
  } catch (e) {
    console.log("can't fetch blogs");
    console.log(e);
    return {
      results: [],
    };
  }
}

export async function searchForPages(query, limit = 25) {
  const url = `/rest/api/search?cql=type in (page) and (title~"${query}*")&limit=${limit}&expand=content.history,content.space&excerpt=none`;
  try {
    const res = await window.AP.request(url);
    const body = JSON.parse(res.body);
    return body;
  } catch (e) {
    console.log("can't fetch blogs");
    console.log(e);
    return {
      results: [],
    };
  }
}
